//
//
//
//

export default {
  name: "select-defaultValue-editor",
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  }
};